/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	ISubTextLabel,
	ITableItem,
} from 'app/interfaces/table-item/table-item.interface';
import { ITextLabel } from 'app/interfaces/text-label/textLabel.interface';
import ImagePath from 'app/utilities/imagePath';
// import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
	TRANSACTION_HISTORY_ENUM,
	transactionHistoryAction,
} from 'app/configs/transactionHistory.config';
import useComponentVisible from 'app/utils/VisibleComponent';
import { downloadTransactionHistoryCsvAction } from 'app/redux/actions/FundingAction';
import ShimmeringLoading from '../ShimmeringLoading/ShimmeringLoading';
import TextLabel from '../TextLabel/TextLabel';
import './TableItem.scss';

const TableItem = function init(props: {
	tableData: ITableItem;
	additionalButton: boolean;
	loading: boolean;
	// eslint-disable-next-line no-unused-vars
	dropdownOnClick: ((data: any) => void) | null;
	// eslint-disable-next-line no-unused-vars
	detailReachBottom: ((data: any) => void) | null;
}): React.ReactElement {
	const { tableData, additionalButton, loading, dropdownOnClick, detailReachBottom } = props;
	const [expand, setExpand] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const { ref, isComponentVisible, setIsComponentVisible } =
		useComponentVisible(false);
	const dispatch = useDispatch();

	function toggleItemDropdown(): void {
		if (!expand && dropdownOnClick) {
			dropdownOnClick(tableData);
		}
		setExpand(!expand);
	}

	function loanStatusRender(status: string): React.ReactElement {
		if (!loading) {
			return (
				<div className={`loanStatus ${status}`}>
					<span>{status}</span>
				</div>
			);
		}
		return <ShimmeringLoading height={24} width={75} />;
	}

	function installmentStatusRender(status: string): React.ReactElement {
		if (!loading) {
			return (
				<div className={`installmentStatus ${status}`}>
					<span>{status}</span>
				</div>
			);
		}

		return <ShimmeringLoading height={24} width={75} />;
	}

	function transactionStatusRender(status: string): React.ReactElement {
		if (!loading) {
			return (
				<div className={`transactionStatus ${status}`}>
					<span>{status}</span>
				</div>
			);
		}
		return <ShimmeringLoading height={24} width={75} />;
	}

	function toggleButtonRender(): React.ReactElement {
		if (!loading) {
			return (
				<button
					className="toggleButton"
					type="button"
					onClick={toggleItemDropdown}
				>
					<img
						src={
							expand
								? ImagePath.arrowUp.src
								: ImagePath.arrowDown.src
						}
						alt={
							expand
								? ImagePath.arrowUp.alt
								: ImagePath.arrowDown.alt
						}
					/>
				</button>
			);
		}
		return <ShimmeringLoading height={24} width={75} />;
	}

	function loadingMoreData(): React.ReactElement | null {
		const { subTextLabel } = tableData;
		let haveMoreData = false;
		if (tableData.detailPagination) {
			haveMoreData =
				subTextLabel.length < tableData.detailPagination.totalData;
			if (haveMoreData) {
				return (
					<div className="table-subItem">
						{subTextLabel[0].textLabel.map(
							(each: ITextLabel, index) => (
								<div
									key={`subItem${index}`}
									style={{
										width: each.width
											? `${each.width}%`
											: `${100 / subTextLabel[0].textLabel.length}%`,
									}}
								>
									<TextLabel
										loading
										bg={each.bg}
										title={each.title}
										value={each.value}
										color={each.color}
									/>
								</div>
							)
						)}
					</div>
				);
			}
			return null;
		}
		return null;
	}

	function detailListRender(): React.ReactElement | null {
		const { subTextLabel } = tableData;
		if (expand && subTextLabel.length > 0) {
			return (
				<div
					id={tableData.id}
					className="sub-item-container"
					style={{
						height: `${
							subTextLabel.length > 5 ? '445px' : 'fit-content'
						}`,
					}}
				>
					{subTextLabel.map((each: ISubTextLabel, index) => (
						<div
							key={`subItemTable${index}`}
							className="table-subItem"
						>
							{each.textLabel &&
								each.textLabel.map(
									(label: ITextLabel, labelIndex) => (
										<div
											key={`subItem${labelIndex}`}
											style={{
												width: label.width
													? `${label.width}%`
													: `${100 / each.textLabel.length}%`,
											}}
										>
											<TextLabel
												bg={label.bg}
												title={label.title}
												value={label.value}
												color={label.color}
											/>
										</div>
									)
								)}
							<div className="action-item">
								{each.loanStatusName &&
									loanStatusRender(each.loanStatusName)}
								{each.installmentStatusName &&
									installmentStatusRender(
										each.installmentStatusName
									)}
							</div>
						</div>
					))}
					{loadingMoreData()}
				</div>
			);
		}

		return null;
	}

	function transactionHistoryItemOnClick(id: number): void {
		if (id === TRANSACTION_HISTORY_ENUM.downloadCsv) {
			const request = {
				bulkFundingNumber: tableData?.transactionNumber
			};
			dispatch(downloadTransactionHistoryCsvAction(request));
		}
	}

	function renderTransactionHistoryItem(
		isDownloadable: boolean | undefined
	): React.ReactElement {
		return (
			<div className="transactionHistoryItem" ref={ref}>
				{isComponentVisible &&
					transactionHistoryAction.map((each) => {
						if (isDownloadable) {
							return (
								<div
									role="button"
									tabIndex={0}
									onKeyPress={() => transactionHistoryItemOnClick(each.id)}
									key={each.label}
									className="transactionHistoryAction"
									onClick={() => transactionHistoryItemOnClick(each.id)}
								>
									{each.label}
								</div>
							);
						}
						return (
							<div
								role="button"
								tabIndex={0}
								key={each.label}
								className="transactionHistoryActionDisabled"
							>
								{each.label}
							</div>
						);
				})}
			</div>
		);
	}

	useEffect(() => {
		const scroller = document.querySelector(`#${tableData.id}`);
		scroller?.addEventListener('scroll', () => {
			const { scrollTop, clientHeight, scrollHeight } = scroller;

			const reachBottom =
				Math.round(scrollTop + clientHeight) >= scrollHeight;
			if (reachBottom && detailReachBottom && !isLoading) {
				setLoading(true);
				detailReachBottom(tableData);
			}
		});
	});

	useEffect(() => {
		setExpand(false);
	}, [tableData.textLabel]);

	return (
		<div className="card table-item-container">
			<div className="table-item">
				{tableData.textLabel &&
					tableData.textLabel.map((each: ITextLabel, index) => (
						<div
							// eslint-disable-next-line react/no-array-index-key
							key={`item${index}`}
							className="value"
							style={{
								width: each.width
									? `${each.width}%`
									: `${100 / tableData.textLabel.length}%`,
							}}
						>
							<TextLabel
								bg={each.bg}
								title={each.title}
								value={each.value}
								color={each.color}
								loading={loading}
							/>
							{tableData.installmentStatusName}
						</div>
					))}
				<div className="action-item">
					{tableData.loanStatusName &&
						loanStatusRender(tableData.loanStatusName || '')}
					{tableData.installmentStatusName &&
						installmentStatusRender(
							tableData.installmentStatusName || ''
						)}
					{tableData.transactionStatusName &&
						transactionStatusRender(
							tableData.transactionStatusName || ''
						)}
					{tableData.showToggleButton && toggleButtonRender()}
				</div>
				{additionalButton ? (
					<div className="actionButton">
						{loading ? (
							<ShimmeringLoading height={24} width={30} />
						) : (
							<button
								className="toggleButton"
								type="button"
								onClick={() => setIsComponentVisible(!isComponentVisible)}
							>
								<img
									src={ImagePath.editDots.src}
									alt={ImagePath.editDots.alt}
								/>
								{renderTransactionHistoryItem(
									tableData?.isDownloadable
								)}
							</button>
						)}
					</div>
				) : null}
			</div>
			<div className="sub-item-container">{detailListRender()}</div>
		</div>
	);
};

export default TableItem;
